// extracted by mini-css-extract-plugin
export default {"app-container":"AppContainer_app-container_GPztCEsLSKiRHSLJ1j12"};